<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="1000"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Edit Shipping Custom</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="dialog = false"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div
        class="modal-body d-flex flex-column h-300px scroll-y mx-5 mx-xl-15 py-7"
      >
        <!--begin::Body-->
        <form id="createForm" class="pa-3 pb-0">
          <v-text-field
            label="Field"
            v-model.trim="$v.formData.field.$model"
            :error-messages="validateState('field') ? errorMessages : ''"
            clearable
            dense
            outlined
          ></v-text-field>
          <v-text-field
            v-model.trim="$v.formData.field_key.$model"
            :error-messages="validateState('field_key') ? errorMessages : ''"
            label="Field Key"
            clearable
            dense
            outlined
          ></v-text-field>
          <v-text-field
            v-model.trim="$v.formData.target_field.$model"
            :error-messages="validateState('target_field') ? errorMessages : ''"
            label="Target Field"
            clearable
            dense
            outlined
          ></v-text-field>
          <v-main class="text-center mt-4">
            <v-btn class="mr-4" color="primary" @click="submitCreateForm">
              submit
            </v-btn>
            <v-btn @click="resetCreateForm"> clear </v-btn>
          </v-main>
        </form>

        <!--end::Body-->

        <!--begin::Actions-->
        <div class="mb-4 d-flex flex-grow-1 align-end justify-center">
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetCreateForm"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitCreateForm"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import Apiservice from "@/core/services/api.service.js";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import Swal from "sweetalert2";

export default {
  mixins: [validationMixin],
  validations: {
    formData: {
      field: { required, maxLength: maxLength(40) },
      field_key: { required, maxLength: maxLength(40) },
      target_field: { required, maxLength: maxLength(40) },
    },
  },
  name: "EditItem",
  props: ["refresher", "loader", "integration_id"],
  data: () => ({
    dialog: false,
    errorMessages: ["This Field is required"],
    formData: {
      custom_id: null,
      field: null,
      field_key: null,
      target_field: null,
    },
  }),
  computed: {
    itemForAction: function () {
      return this.$store.getters.getItemForAction;
    },
  },
  methods: {
    toggleModal() {
      if (this.dialog) this.resetCreateForm();
      this.dialog = !this.dialog;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.formData[name];
      return $dirty ? $error : null;
    },
    submitCreateForm() {
      this.$v.formData.$touch();
      if (this.$v.formData.$anyError) {
        return;
      }
      this.loader(true);
      let data = { ...this.formData, integration_id: this.integration_id };
      Apiservice.post("", data)
        .then(() => {
          Swal.fire({
            title: "Updated",
            text: "The Shipping Custom Data has been Updated",
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.toggleModal();
          this.refresher();
        })
        .catch(() => {
          this.loader(false);
        });
    },
    resetCreateForm() {
      this.formData.custom_id = this.itemForAction.id;
      this.formData.field = this.itemForAction.field;
      this.formData.field_key = this.itemForAction.fieldKey;
      this.formData.target_field = this.itemForAction.targetField;
    },
  },
};
</script>
